import React, { type PropsWithChildren } from 'react';
import { StyleSheet, type TextStyle } from 'react-native';
import { theme, TitleText } from '@sg/garnish';

export const LoyaltyPostPurchaseTitle = (
  props: LoyaltyPostPurchaseTitleProps,
) => {
  const { children, style } = props;

  return (
    <TitleText sizeMatch={['40']} style={[styles.title, style]}>
      {children}
    </TitleText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.SWEET_CORN,
    marginTop: theme.spacing['16'],
    textAlign: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyPostPurchaseTitleProps = PropsWithChildren<{
  style?: TextStyle;
}>;
